import React, { useEffect } from "react";

function Terms() {
	useEffect(() => {
		document.title = "Terms & Conditions";
	}, []);
	return (
		<div className="wrapper">
			<div className="top-fold">
				<div className="container">
					<div className="container--inner">
						<h1>Terms & Conditions</h1>
					</div>
				</div>
			</div>
			<div className="bottom-fold">
				<div className="container">
					<div className="container--inner">
						<p>
							At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no
							sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
							consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
							dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo
							dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
							ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, At
							accusam aliquyam diam diam dolore dolores duo eirmod eos erat, et nonumy sed tempor et
							et invidunt justo labore Stet clita ea et gubergren, kasd magna no rebum. sanctus sea
							sed takimata ut vero voluptua. est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit
							amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
							dolore magna aliquyam erat.
						</p>

						<p>
							Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis
							nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit
							in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla
							facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent
							luptatum zzril delenit augue duis dolore te feugait nulla facilisi.
						</p>

						<p>
							Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
							invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
							accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
							sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
							sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna
							aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
							rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit
							amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod
							tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero
							eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
							takimata sanctus est Lorem ipsum dolor sit amet.
						</p>

						<p>
							Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie
							consequat, vel illum dolore eu feugiat nulla facilisis.
						</p>

						<p>
							Nam liber tempor cum soluta nobis eleifend option congue nihil imperdiet doming id
							quod mazim placerat facer possim assum. Lorem ipsum dolor sit amet, consectetuer
							adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna
							aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation
							ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
						</p>

						<p>
							Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
							dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo
							dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
							ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
							diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
							voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd
							gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor
							sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut
							labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et
							justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Terms;
